// @ts-ignore
import React, { ReactElement } from 'react';
// import { AlphabetFilter } from './alphabet-search';
import { FilterType } from 'models/filter-type';
import { SelectDefinition } from 'models/select-definition';
import { TextBoxDefinition } from 'models/text-box-definition';
import { KeywordSearch } from './keyword-search';

const FilterTypeChooser = ({ item, mobileSelector }: iFilterTypeChooser): ReactElement | null => {
    switch (item.type) {
        case FilterType.TextBox:
            return (
                <div className={`filter-panel__input${mobileSelector ? ' is-mobile' : ''}`}>
                    <KeywordSearch {...(item as TextBoxDefinition)} />
                </div>
            );
        default:
            return null;
    }
};

interface iFilterTypeChooser {
    item: TextBoxDefinition | SelectDefinition;
    mobileSelector: boolean;
}

export { FilterTypeChooser };
